/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable quotes */
/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useCallback, useMemo, useState } from 'react'
import './AttentionRequiredChargers.css';
import { Icon, IconWithTooltip } from '../../globalUtils/globalIcons';
import { getDashboardReducer, setFilterData, setRedirectedStateForAlarmFilters } from '../../rmsReduxStore/reduxExports';
import { useAppDispatch, useAppSelector } from '../../rmsReduxStore/rmsReduxHooks';
import { RectangularSkeleton } from '../../globalUtils/SkeletonDesign/SkeletonDesign';
import { useNavigate } from 'react-router-dom';
import { AlarmPulseLoader, CustomTooltipWithLabel } from '../../globalUtils/globalExports';
import { isArray } from 'lodash';
import access from '../../auth/service/AccessControl';

interface AttentionRequiredProp {
  handleFilter: Function,
  getFilterValue: Function
}
const AttentionRequiredChargers: React.FC<AttentionRequiredProp> = (props) => {
  const { handleFilter, getFilterValue } = props;
    const allTabs = ['uptime','utilization','failedTransactions','criticalAlarms', 'oldFirmware', 'offlineChargers', 'session'];
    const tabs = allTabs?.filter(tab => {
      const isAccessible = access?.newDashboard?.tiles?.attentionRequiredChargersCards?.[tab];
      return typeof isAccessible === 'function' && isAccessible();
    });
    const [activeTab, setActiveTab] = useState(getFilterValue('keyType')?.[0]?.value || 'criticalAlarms');

    const { newDashboardAttentionRequiredInfo } = useAppSelector(getDashboardReducer);
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const widgetHeight = 430;

    const categoryMap: Record<string, string> = {
      'uptime':'Uptime',
      'utilization':'Utilization',
      'failedTransactions': 'Txn Failure',
      'criticalAlarms': 'Critical Alarm',
      'offlineChargers': 'Offline',
      'oldFirmware': 'Old Firmware',
      'session': 'Session',
    };

    const options = [
      {
        'id': 'uptime',
        'value': 'uptime',
        'label': 'uptime',
        'name': 'uptime'
      },
      {
        'id': 'utilization',
        'value': 'utilization',
        'label': 'utilization',
        'name': 'utilization'
      },
      {
        'id': 'failedTransactions',
        'value': 'failedTransactions',
        'label': 'failedTransactions',
        'name': 'failedTransactions'
      },
      {
        'id': 'criticalAlarms',
        'value': 'criticalAlarms',
        'label': 'criticalAlarms',
        'name': 'criticalAlarms'
      },
      {
        'id': 'offlineChargers',
        'value': 'offlineChargers',
        'label': 'offlineChargers',
        'name': 'offlineChargers'
      },
      {
        'id': 'oldFirmware',
        'value': 'oldFirmware',
        'label': 'oldFirmware',
        'name': 'oldFirmware'
      },
      {
        'id': 'session',
        'value': 'session',
        'label': 'session',
        'name': 'session'
      },
    ]

    const formattedData = useMemo(() => {
      if(newDashboardAttentionRequiredInfo && !isArray(newDashboardAttentionRequiredInfo))return [];
      return newDashboardAttentionRequiredInfo
    }, [newDashboardAttentionRequiredInfo]);

      const handleSelectedAlarm = useCallback(
        async (event: React.MouseEvent, data: INewDashboardAttentionRequiredInfo) => {
          if (activeTab === 'criticalAlarms') {
            try {

            const chargerList = [{
              id: data.id,
              value: data.id,
              label: data.visibleId,
              name: data.visibleId
          }];
              await setRedirectedStateForAlarmFilters(true, 'Critical')(dispatch)
              await setFilterData(chargerList, 'chargerId', 'alarms', 'SET', false)(dispatch)
              navigate('/alarms')
            
            } catch (error) {
              console.error('Error fetching alarm data:', error);
            }
          } else {
            navigate('/charger?chargerId=' + data.visibleId, {
              state: {
                chargerId: data?.id,
              },
            });
          }
        },
        [navigate, activeTab, dispatch, setRedirectedStateForAlarmFilters]
      );


  const handleAttentionRequiredFilter = useCallback(async (val: any): Promise<void> => {
    const res = await setFilterData(val, 'keyType', 'dashboardV2', 'SET', false)(dispatch)
    if (res?.message === 'Action dispatched successfully') {
        handleFilter(res?.filters);
    }
  }, [setFilterData])

      const getAlarmClass = (tab: string): string => {
        switch (tab) {
          case 'uptime':
            return 'uptime';
          case 'utilization':
            return 'utilization';
          case 'failedTransactions':
            return 'txn-failure';
          case 'criticalAlarms':
            return 'critical-alarm';
          case 'oldFirmware':
            return 'old-firmware';
          case 'offlineChargers':
            return 'offline';
          case 'session':
            return 'charging-session';          
          default:
            return 'critical-alarm';
        }
      };

      const handleTabChange = async (tab: string, isInitialCall?: boolean) => {
        const filter = options.filter((option) => option.id === tab);
      
        if (!isInitialCall) await handleAttentionRequiredFilter(filter);
        setActiveTab(tab);
      };
      

    return (
      <div className='widget-wrap'>
        <div className='widget-header attention-required-container-header'>
          <div className='attention-required-container-heading-sub-heading'>
            <div className='attention-required-container-heading-container'>
                <div className='widget-heading attention-required-container-heading'>
                Attention Required Chargers
                <IconWithTooltip
                    iconClassName='info-icon'
                    toolTipText={'List of chargers with critical alarms, older firmware versions, transaction failures, and connectivity fluctuations'}
                    containerClassName={'new-dashboard-widget-header-tooltip'}
                />
                </div>
            </div>
          </div>
          <div className='attention-required-filters'>
          {/* Future dropdown or filters */}
          </div>
        </div>

        <div className='widget-body attention-required-body'>
          <div className='tab-container'>
            {tabs?.map((tab) => (
              <div
                key={tab}
                className={`tab-item ${activeTab === tab ? 'active' : ''}`}
                onClick={() => handleTabChange(tab)}
              >
                {
                  (tab==='uptime' || tab==='utilization')  && 
                  <Icon iconClassName={activeTab===tab ? 'attention-requrired-arrow-down-active':'attention-requrired-arrow-down'}/>
                }
                <span className='tab-text'>{categoryMap[tab]}</span>
              </div>
            ))}
          </div>

          <div className='alarm-list'>
            {!formattedData ? (
              <div style={{ 
              height: `${widgetHeight}px` ,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'}}>
                <AlarmPulseLoader showLoader={true} />
              </div>
              ) : formattedData.length === 0 ? (
                <div className='no-data-text' style={{ height: `${widgetHeight}px`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  No Data Available
                </div>
              ) :  (
                  formattedData?.map((item, index) => (
                    <div
                      className={`alarm-item ${getAlarmClass(activeTab)}`}
                      key={index}
                      onClick={(event) => handleSelectedAlarm(event, item)}
                      style={{ cursor: 'pointer' }}
                    >
                    <div className='alarm-text'>
                      <div className='alarm-text-header'>
                        <div className='charger-id'>{item?.visibleId}</div>
                        <div className='charger-details'>
                          <div className={item?.ocppId ? 'charger-ocpp-id':'charger-ocpp-id-missing'}><CustomTooltipWithLabel label={item?.ocppId ? item?.ocppId : '-' } labelId={'ocpp-id-' + item?.id} /></div>
                          <div className='data-separator'></div>
                          <div className='charger-charging-station'><CustomTooltipWithLabel label={item?.chargingStationName ? item?.chargingStationName : '-' } labelId={'charging-station-id-'+item?.id}/></div>
                        </div>
                      </div>
                      <div className={`alarm-message ${getAlarmClass(activeTab)}`}>
                        <CustomTooltipWithLabel 
                          label={Array.isArray(item.description) ? item.description.join(', ') : (activeTab==='uptime' || activeTab === 'utilization') ? (item?.description as number)?.toFixed(2).padStart(5,'0') + ' %' : item?.description?.toString()} 
                          labelId={Array.isArray(item.description) ? item.description.join(', ') : item?.description?.toString()} 
                          />
                      </div>
                    </div>
                    <div className='rms__icon attention-required-arrow-right' />
                  </div>
                ))
              )}
          </div>
        </div>
      </div>
    )
}

export default AttentionRequiredChargers